export default class MultiValueMap<K, V> extends Map<K, Set<V>> {
  add(key: K, value: V): void {
    let entry = this.get(key);
    if (!entry) {
      entry = new Set<V>();
      this.set(key, entry);
    }
    entry.add(value);
  }

  addAll(other: Iterable<[K, Set<V>]>): void {
    for (const [key, values] of other) {
      for (const value of values) {
        this.add(key, value);
      }
    }
  }

  remove(key: K, value: V): void {
    const values = this.get(key);
    if (values) {
      values.delete(value);
      if (values.size === 0) {
        this.delete(key);
      }
    }
  }

  get(key: K): Set<V> | undefined {
    return super.get(key);
  }
}
